export default "__VITE_ASSET__TrlgXUVO__"